module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('h1', [_vm._v("En construcción")]), _vm._v(" "), _c('h3', [_vm._v("Proximamente estará dispobible")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/images/bird.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9018f240"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/EnContstruccion.vue
// module id = 1156
// module chunks = 5